import { IconProps } from '@mui/material'
import React from 'react'

const Unfold: React.FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.51574 3.55402C4.2773 3.31557 4.2773 2.92899 4.51574 2.69055C4.75419 2.45211 5.14077 2.45211 5.37921 2.69055L8.0003 5.31164L10.6214 2.69055C10.8598 2.45211 11.2464 2.45211 11.4848 2.69055C11.7233 2.92899 11.7233 3.31557 11.4848 3.55402L8.43203 6.60684C8.31754 6.72134 8.16222 6.78566 8.0003 6.78566C7.83837 6.78566 7.68305 6.72134 7.56857 6.60684L4.51574 3.55402ZM11.4848 12.4596C11.7233 12.698 11.7233 13.0846 11.4848 13.323C11.2464 13.5615 10.8598 13.5615 10.6214 13.323L8.0003 10.7019L5.37921 13.323C5.14077 13.5615 4.75419 13.5615 4.51574 13.323C4.2773 13.0846 4.2773 12.698 4.51574 12.4596L7.56857 9.40675C7.80699 9.16833 8.1936 9.16833 8.43203 9.40675L11.4848 12.4596Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Unfold
